import { useEffect } from 'react';
import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { useOffers } from 'merchant-api/offer';
import useParties from '../useParties/useParties';
import { spiceroad } from '..';

export interface UseMerchantValidationProps {
  data: any;
  isErrorMerchantValidation: Error | null;
  isLoadingMerchantValidation: boolean;
  mutation: UseMutationResult<any, Error, any>;
}

export function useMerchantValidation(): UseMerchantValidationProps {
  const { isRenewal } = useParties();
  const { locOffer, tlOffer, isLoadingOffers } = useOffers();

  const mutation = useMutation({
    mutationFn: (arg: any) =>
      spiceroad.post('/v2/merchant/validate', arg).then((res) => res.data),
    mutationKey: ['merchantValidation'],
  });

  useEffect(() => {
    if (!isLoadingOffers && (tlOffer || locOffer) && isRenewal) {
      mutation.mutate({});
    }
  }, [isLoadingOffers, tlOffer, locOffer]);

  useEffect(() => {
    if (!mutation.isPending && mutation.error) {
      throw new Error('ERROR: Loan validation failed');
    }
  }, [mutation.isPending, mutation.error]);

  return {
    data: mutation.data,
    isErrorMerchantValidation: mutation.error,
    isLoadingMerchantValidation: mutation.isPending,
    mutation,
  };
}

export default useMerchantValidation;
